import React, { FC, ReactElement, Fragment } from 'react'
import ParkingModules from '../../components/parking-modules'
import ServicesFooter from '../../components/services-footer'
import {
  Centre,
  AutomatedCollection,
  RawOpeningHours,
} from '../../../types/contentful-v1'
import { ParkingModule, CFParkingTemplate } from '../../../types/contentful'
import { MetaData } from '../../../types/meta-data'
import withParkingModules from '../../containers/with-parking-modules'
import pagesHoc from '../pages-hoc'
import withModules from '../../containers/with-modules'
import withCentreTradingHours from '../../containers/with-centre-trading-hours'
import { PromotionPositionContext } from '../../context'
import styles from './index.scss'
interface ParkingProps {
  centre?: Centre
  parkingModules?: ParkingModule[]
  loading?: boolean
  // N.B. in general modules can be many things but we have an expectation
  // that for our particular query there's just one module, an automated
  // collection of services in a spotlight
  modules?: AutomatedCollection[]
  centreTradingHours: RawOpeningHours
  parkingTemplate: CFParkingTemplate
}

const Parking: FC<ParkingProps> = ({
  loading,
  centre,
  parkingModules,
  modules: serviceModules,
  centreTradingHours,
  parkingTemplate,
}: ParkingProps): ReactElement => {
  if (loading || !centre) {
    return <pre>Loading...</pre>
  }
  const className = styles.initialContentGroup
  const displayId =
    parkingTemplate.analyticsMetadata &&
    parkingTemplate.analyticsMetadata.displayId
  return (
    <Fragment>
      <PromotionPositionContext.Provider value={displayId}>
        <ParkingModules
          centre={centre}
          centreTradingHours={centreTradingHours}
          modules={parkingModules || []}
        />
        <ServicesFooter {...{ centre, className, serviceModules }} />
      </PromotionPositionContext.Provider>
    </Fragment>
  )
}

function getMetaData({ centre }: { centre?: Centre }): MetaData {
  const { title }: { title?: string } = centre || {}
  const fullTitle = `Westfield${title ? ` ${title}` : ''}`
  return {
    title: `${fullTitle} Parking | Parking Rates & Fees`,
    description: `${fullTitle} offers you secure car parking. Check parking information including entrances, hourly rates and more at ${fullTitle}`,
  }
}

export default withParkingModules(
  // NB: Fixing this was very bad effort to value
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  withModules(withCentreTradingHours(pagesHoc(Parking, getMetaData)))
)
